import { createChildListViewComponent } from 'factories/ChildListView'
import entityNames from 'options/entityNames'
import FormView from 'containers/Products/SupplierDetails/FormView'

export default createChildListViewComponent({
  entityName: entityNames.products,
  childName: 'supplierDetails',
  createButtonTextId: 'addSupplierDetail',
  createButtonLinkTarget: {
    formSize: 'xs',
    formComponent: FormView,
  },
  primaryLinkTarget: 'supplierDetailRecord',
  getRowClassName: (self) => (record, index) =>
    record.supplierId === self.props.parentRecord?.defaultSupplierId ? 'table-row-success' : '',
})()
